export default __webpack_public_path__ + "static/media/guia-escritorio-dark-2.4e7827ce.png";